<template>
    <div>
        <product   :order.sync="revise_order" :old-order="orderData"></product>
        <finance_contract  :order.sync="revise_order" :old-order="orderData"></finance_contract>
        <performance  :order.sync="revise_order" :old-order="orderData"></performance>
        <repay_plan   :order="revise_order" :old-order="orderData"></repay_plan>
        <invoice  :order="revise_order" :old-order="orderData"></invoice>
        <express  :order="revise_order" :old-order="orderData"></express>
    </div>
</template>

<script>
    import product from "~/views/order/finance/product.vue";
    import repay_plan from "~/views/order/finance/repay_plan.vue";
    import finance_contract from "~/views/order/finance/finance_contract.vue";
    import invoice from "~/views/order/finance/invoice.vue";
    import performance from "~/views/order/finance/performance.vue";
    import express from "~/views/order/finance/express.vue";
    export default {
        name: "revise_finance",
        props:{
            order_edit:{
                required:true
            }
        },
        components:{
            product,
            repay_plan,
            finance_contract,
            invoice,
            performance,
            express
        },
        data(){
            return {
                revise_order:{},
                orderData:{}
            }
        },
        mounted(){
            this.buildOrder();
            this.buildOldOrder();
        },
        methods:{
            buildOrder(){
                let user = this.order_edit.content.cooperator ? this.order_edit.content.cooperator : this.order_edit.content.user;
                // user.unshift({
                //     name: this.order_edit.content.sale_name,
                //     user_id: this.order_edit.content.sale,
                //     pfm_amount: this.order_edit.content.performance_amount,
                //     is_cooperator: 0
                // });
                this.revise_order = Object.assign({},this.order_edit, {
                    finance: this.order_edit.content,
                    user: user,
                });
            },
            buildOldOrder(){
                this.orderData = this.order_edit.before_content;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/revise_finance.vue